import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const FluencyChallengeSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const steps = [1, 2, 3];

  const handleBackToChallenge = () => {
    navigate("/fluency-challenge");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F0FDF1] px-4">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-2xl rounded-3xl bg-white p-8 text-center shadow-2xl"
      >
        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mb-6 flex justify-center"
        >
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#E9F7EF]">
            <CheckCircle className="h-12 w-12 text-[#14B82C]" />
          </div>
        </motion.div>

        {/* Main Content */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <h1 className="mb-4 text-4xl font-bold text-[#042F0C]">
            {t("fluencyChallenge.success.title")}
          </h1>

          <p className="mb-8 text-xl leading-relaxed text-[#3D3D3D]">
            {t("fluencyChallenge.success.description")}
          </p>

          {/* Next Steps Section */}
          <div className="mb-8 rounded-2xl bg-[#FFFFEA] p-6 text-left">
            <h2 className="mb-4 text-xl font-semibold text-[#042F0C]">
              {t("fluencyChallenge.success.nextSteps")}
            </h2>
            <div className="space-y-3">
              {steps.map((step) => (
                <div key={step} className="flex items-start gap-3">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[#14B82C]">
                    <span className="text-sm font-bold text-white">{step}</span>
                  </div>
                  <p className="text-[#3D3D3D]">
                    {t(`fluencyChallenge.success.step${step}`)}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Exam Prep CTA Section */}
          <div className="mb-8 rounded-2xl bg-[#F0FDF1] p-6 text-center">
            <h3 className="mb-2 text-xl font-semibold text-[#042F0C]">
              {t("fluencyChallenge.success.examPrepTitle")}
            </h3>
            <p className="mb-4 text-[#3D3D3D]">
              {t("fluencyChallenge.success.examPrepSubtitle")}
            </p>
            <Link
              to="/exam-prep"
              className="inline-block rounded-full bg-[#14B82C] px-6 py-2 text-base font-semibold text-white transition-colors hover:bg-green-700"
            >
              {t("fluencyChallenge.success.accessExamPrep")}
            </Link>
          </div>

          {/* Back to Home Button */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleBackToChallenge}
            className="rounded-full bg-[#14B82C] px-8 py-3 text-lg font-semibold text-white transition-colors hover:bg-green-700"
          >
            {t("fluencyChallenge.success.backButton")}
          </motion.button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default FluencyChallengeSuccess;
